var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicySm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37492 8.64584L7.79159 10.0625L10.9791 6.87501M14.1666 9.00001C14.1666 12.4768 10.3742 15.0055 8.99433 15.8105C8.83751 15.902 8.7591 15.9478 8.64844 15.9715C8.56256 15.9899 8.43727 15.9899 8.3514 15.9715C8.24074 15.9478 8.16233 15.902 8.00551 15.8105C6.62564 15.0055 2.83325 12.4768 2.83325 9.00001V5.61248C2.83325 5.04616 2.83325 4.763 2.92587 4.51959C3.0077 4.30457 3.14066 4.11271 3.31326 3.96059C3.50864 3.7884 3.77378 3.68898 4.30404 3.49013L8.10198 2.0659C8.24924 2.01068 8.32287 1.98307 8.39862 1.97213C8.4658 1.96242 8.53403 1.96242 8.60122 1.97213C8.67697 1.98307 8.7506 2.01068 8.89786 2.0659L12.6958 3.49013C13.2261 3.68898 13.4912 3.7884 13.6866 3.96059C13.8592 4.11271 13.9921 4.30457 14.074 4.51959C14.1666 4.763 14.1666 5.04616 14.1666 5.61248V9.00001Z",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicySm);
export default __webpack_public_path__ + "static/media/policy-sm.dae5afe909b9f807d6bf079dc07b3b61.svg";
export { ForwardRef as ReactComponent };